import React from 'react'
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    Text,
    Flex,
    Button,
} from '@chakra-ui/react'

export enum ModalType {
    Delete = 'delete',
    Confirm = 'confirm',
    Warning = 'warning',
}

interface Props {
    type: ModalType
    itemType: string
    onConfirm: () => void
    isOpen: boolean
    onClose: () => void
    isLoading?: boolean
    actionWord?: string
    headerOverride?: string
    helpTextOverride?: string
}

const ConfirmModal: React.FC<Props> = ({
    type,
    itemType,
    onConfirm,
    isLoading = false,
    isOpen,
    onClose,
    actionWord,
    headerOverride,
    helpTextOverride,
}) => {
    const { primaryColor, action, buttonScheme, headerColor } = {
        [ModalType.Delete]: {
            primaryColor: 'red.500',
            buttonScheme: 'red',
            action: actionWord || 'delete',
        },
        [ModalType.Confirm]: {
            primaryColor: 'brand.500',
            buttonScheme: 'brand',
            action: actionWord || 'confirm',
        },
        [ModalType.Warning]: {
            primaryColor: 'yellow.500',
            headerColor: 'black',
            buttonScheme: 'yellow',
            action: actionWord || 'confirm',
        },
    }[type]

    const handleClose = () => {
        onClose()
    }

    return (
        <Modal isOpen={isOpen} onClose={handleClose} size="lg">
            <ModalOverlay>
                <ModalContent overflow="hidden">
                    <ModalHeader
                        borderBottomWidth={2}
                        borderBottomColor={primaryColor}
                    >
                        {action.capitalize()} {itemType}?
                    </ModalHeader>
                    <ModalBody my={4}>
                        <Text fontWeight="semibold" fontSize="md" mb={2}>
                            {headerOverride ||
                                `Are you sure you want to ${action} this ${itemType}?`}
                        </Text>
                        <Text color="gray.500" fontSize="14px">
                            {helpTextOverride ||
                                'This action cannot be undone.'}
                        </Text>
                    </ModalBody>
                    <ModalFooter>
                        <Flex justify="space-between" w="full">
                            <Button
                                colorScheme="gray"
                                variant="subtle"
                                onClick={handleClose}
                                mr={2}
                                autoFocus
                            >
                                Cancel
                            </Button>
                            <Button
                                onClick={() => onConfirm()}
                                isLoading={isLoading}
                                colorScheme={buttonScheme}
                            >
                                {action.capitalize()}
                            </Button>
                        </Flex>
                    </ModalFooter>
                </ModalContent>
            </ModalOverlay>
        </Modal>
    )
}

export default ConfirmModal
